const signalR = require('@aspnet/signalr')
const baseUrl = process.env.NODE_ENV === 'production' ? 'https://uccjpl.codingstorm.com' : 'http://localhost:5000'
let connection = new signalR.HubConnectionBuilder()
    .withUrl(`${baseUrl}/api/message`, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => localStorage.token
    })
    .configureLogging(signalR.LogLevel.Error)
    .build()

connection.onclose(err => {
  console.log(err)
  connection.start()
  .then(() => console.log('重新连接MessageCenter成功！'))
  .catch(() => console.log('重新连接MessageCenter失败'))
})

connection.on('send', data => {
  console.log(data)
})

connection.start()
.then(() => console.log('连接message center成功！'))
.catch((err) => console.log('连接message center失败！', err))

const printTicket = (ticket) => {
  return new Promise((resolve, reject) => {
    connection.invoke('PrintTicket', ticket)
    .then(res => {
      console.log('打印成功！')
      resolve(res)
    })
    .catch(res => {
      console.log('打印失败！')
      connection.start()
      .then(res => {
        connection.invoke('PrintTicket', ticket)
        .then(res => {
          console.log('重连之后打印成功')
          resolve(res)
        })
        .catch(res => {
          console.log('重连之后打印失败')
          reject(res)
        })
      })
    })
  })
}
// connection.start()
//     .then(() => connection.invoke('send', 'Hello'))
//     .then((err) => console.log(err))

function install(Vue) {
  Vue.prototype.$center = connection
  Vue.prototype.$printTicket = printTicket
}

export default install



// WEBPACK FOOTER //
// ./src/MessageCenter.js